import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { apiClient } from "@/lib/api";
import { CreditCard } from "lucide-react";

export default function BillingHistory() {
  const handleManageBilling = async () => {
    try {
      const { url } = await apiClient.createBillingPortalSession();
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error creating billing portal session:", error);
    }
  };
  return (
    <Card className="overflow-hidden bg-white/80 shadow-sm">
      <CardHeader className="border-b border-stone-100">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <CardTitle>Billing Management</CardTitle>
          <Button variant="outline" onClick={handleManageBilling}>
            <CreditCard className="w-4 h-4 mr-2" />
            Manage Billing
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-stone-600">
          Access your billing portal to update payment methods, download
          invoices, and manage your subscription.
        </p>
      </CardContent>
    </Card>
  );
}
